import React, { useState,useEffect, useRef } from "react";

function Manuals() {
    const [menuOpen, setMenuOpen] = useState(false);
  return (
    <>
  <header
  style={{
    position: "sticky",
    top: 0,
    zIndex: 1000,
    background: "#fff",
    padding: "18px 7%",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    boxShadow: "0 4px 20px rgba(0,0,0,.08)",
    width:"100%"
  }}
>
  <a
    href="/"
    style={{
      display: "flex",
      alignItems: "center",
      gap: "15px",
      textDecoration: "none",
    }}
  >
    <img
      src="/images/SDC3-01-1.png"
      alt="SDC Logo"
      style={{ height: 58 }}
    />

    
  </a>

  <a
    href="/"
    style={{
      textDecoration: "none",
      color: "#0092d7",
      background: "transparent",
      padding: "12px 24px",
      borderRadius: "30px",
      fontWeight: 600,
    }}
  >
      ← Back to Home
  </a>
</header>
           <section
  id="manuals"
  style={{
    padding: "50px 7%",
    background: "#eef6fb", // soft blue
    textAlign: "center",
    borderTop: "1px solid #d7e8f3",
  }}
>

  <h2
    style={{
      fontSize: "2.3rem",
      fontWeight: "700",
      color: "#003366",
      marginBottom: "10px",
      
    }}
  >
    Portal User Manuals
  </h2>

  <p
    style={{
      maxWidth: "700px",
      margin: "0 auto 50px",
      color: "#555",
      fontSize: "16px",
      lineHeight: "1.7",
    }}
  >
    Download the appropriate user manual to learn how to access and use the
    Students and Staff Portal.
  </p>

  <div
    style={{
      display: "flex",
      justifyContent: "center",
      flexWrap: "wrap",
      gap: "30px",
    }}
  >
    {/* Staff Manual */}
    <div
      style={{
        background: "#fff",
        width: "340px",
        padding: "35px 25px",
        borderRadius: "16px",
        boxShadow: "0 10px 25px rgba(0,0,0,0.08)",
        transition: "0.3s",
      }}
    >
      <div style={{ fontSize: "60px", marginBottom: "20px" }}>📘</div>

      <h3
        style={{
          color: "#003366",
          marginBottom: "15px",
        }}
      >
        Staff Portal Manual
      </h3>

      <p
        style={{
          color: "#666",
          lineHeight: "1.6",
          marginBottom: "25px",
        }}
      >
        Step-by-step guide for staff members on logging in, changing passwords,
        and using the Staff Portal.
      </p>

      <a
        href="/docs/STAFF PORTAL LOGIN GUIDE.pdf"
        target="_blank"
        rel="noopener noreferrer"
        style={{
          display: "inline-block",
          background: "#0092d7",
          color: "#fff",
          padding: "12px 28px",
          borderRadius: "30px",
          textDecoration: "none",
          fontWeight: "600",
        }}
      >
        View Staff Manual
      </a>
    </div>

    {/* Student Manual */}
    <div
      style={{
        background: "#fff",
        width: "340px",
        padding: "35px 25px",
        borderRadius: "16px",
        boxShadow: "0 10px 25px rgba(0,0,0,0.08)",
      }}
    >
      <div style={{ fontSize: "60px", marginBottom: "20px" }}>🎓</div>

      <h3
        style={{
          color: "#003366",
          marginBottom: "15px",
        }}
      >
        Student Portal Manual
      </h3>

      <p
        style={{
          color: "#666",
          lineHeight: "1.6",
          marginBottom: "25px",
        }}
      >
        Learn how to log in, change your password, and access all features
        available in the Student Portal.
      </p>

      <a
        href="/docs/STUDENT PORTAL LOGIN GUIDE.pdf"
        target="_blank"
        rel="noopener noreferrer"
        style={{
          display: "inline-block",
          background: "#cdd83b",
          color: "#000",
          padding: "12px 28px",
          borderRadius: "30px",
          textDecoration: "none",
          fontWeight: "600",
        }}
      >
        View Student Manual
      </a>
    </div>
  </div>
</section>
{/* FOOTER */}
        <section className="footer-section" id="footer">
          <footer className="footer">
            <div className="footer-logo">
              <img src="images\SDC3-01-1.png" alt="Logo" />
              <p className="footer-brand">Software Development Centre</p>
            </div>
            <div>
              <h3>Site Links</h3>
              <ul>
                <li><a href="#home">Home</a></li>
                <li><a href="#about">About Us</a></li>
                <li><a href="#services">Services</a></li>
                <li><a href="#projects">Projects</a></li>
                <li><a href="#contact">Contact</a></li>
                <li><a href="/manuals">Manuals</a></li>
              </ul>
            </div>
            <div>
              <h3>Contacts</h3>
              <p>sdc@dkut.ac.ke</p>
            </div>
            <div>
              <h3>Code of Ethics</h3>
              <p>Software Development <br></br>Centre is a corruption-free zone and maintains a zero-tolerance policy on drug use, fostering integrity and professionalism.</p>
            </div>
            <div>
              <h3>Location</h3>
              <p>Dedan Kimathi University Of Technology - Resource Centre</p>
            </div>
          </footer>
          <div className="copyright">
            <p>@Copyright 2026. All Rights Reserved. Software Development Centre</p>
          </div>
        </section>


    </>
    
  );
}

export default Manuals;